import React, {useEffect, useState} from 'react';
import {collection, query, onSnapshot, updateDoc, doc} from "firebase/firestore";
import db from "../../firebase";
import { useForm } from "react-hook-form";

const modalStyle = {
  marginLeft: 3,
  marginRight: 3
}
const EditCardModal = (props) => {
  const {statuses, card} = props
  const [priorities, setPriorities] = useState([]);
  const { register, handleSubmit, reset} = useForm({mode: 'onChange'}, { defaultValues: {
	  title: card.title,
	  status: card.status,
	  priority: card.priority,
	  description: card.description
	}});
  const onSubmit = async (data) => {
	console.log(data);
	if(data) {
	  await updateDoc(doc(db, 'cards', card.id), {
		title: data.title,
		description: data.description,
		status: data.status,
		priority: +data.priority
	  });
	}
	reset({
	  title: data.title,
	  description: data.description,
	  status: data.status,
	  priority: +data.priority
	})
	alert('Your updates was done successfully! You can close the modal now by clicking on "X" or Cancel button or continue updating.')
  }

  const getPriorities = () => {
	const prioritiesColRef = query(collection(db, "priorities"));
	onSnapshot(prioritiesColRef, (snapshot) => {
	  setPriorities(
		snapshot.docs.map((doc) => ({
		  id: doc.id,
		  ...doc.data(),
		}))
	  );
	});
  }

  useEffect(() => {
	getPriorities();
	(() => {
	  // Fetch all the forms we want to apply custom Bootstrap validation styles to
	  const forms = document.querySelectorAll('.needs-validation')
	  // Loop over them and prevent submission
	  Array.from(forms).forEach(form => {
		form.addEventListener('submit', event => {
		  if (!form.checkValidity()) {
			event.preventDefault()
			event.stopPropagation()
		  }
		  form.classList.add('was-validated')
		}, false)
	  })
	})()
  }, [])

  return (
	<>
	  <button type="button" className="btn btn-sm btn-outline-warning edit"
			  data-bs-toggle="modal"
			  data-bs-target={`#${card.id}`}
	  >
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
			 className="bi bi-pencil-square" viewBox="0 0 16 16">
		  <path
			d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
		  <path fillRule="evenodd"
				d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
		</svg>
	  </button>
	   <div className="modal fade"
		   id={`${card.id}`}
		   tabIndex="-1"
		   aria-hidden="true"
		   aria-labelledby="editCardModalLabel"
		   data-bs-backdrop="false" data-bs-keyboard="false"
	  >
		<div className="modal-dialog">
		  <div className="modal-content">
			<div className="modal-header">
			  <h1 className="modal-title fs-5" id="editCardModalLabel">Update your task</h1>
			  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div className="modal-body">
			</div>
			<form action='#'
			  className="row g-3 needs-validation" noValidate
				  onSubmit={handleSubmit(onSubmit)}>
			  <div className="row mb-3"  style={modalStyle}>
				<label htmlFor="summary" className="col-sm-3 col-form-label">Summary*</label>
				<div className="col-sm-9">
				  <input type="text" className="form-control" id="summary"
						 defaultValue={card.title}
						 required
						 {...register("title")}/>
				  <div className="invalid-feedback">
					This field is required.
				  </div>
				</div>
			  </div>
			  <div className="row mb-3"  style={modalStyle}>
				<label htmlFor="description" className="col-sm-3 col-form-label">Description</label>
				<div className="col-sm-9">
				  <textarea className="form-control"  id="description"
							defaultValue={card.description}
							{...register("description")}>
				  </textarea>
				</div>
			  </div>
			  <div className="row mb-3"  style={modalStyle}>
				<label htmlFor="priority" className="col-sm-3 col-form-label">Priority*</label>
				<div className="col-sm-9">
				  <select className="form-select form-select-sm" id="priority"
						  required
						  {...register("priority")}>
					<option selected value={card.priority}>{card.priority}</option>
					{priorities.map(el => {
					  return <option value={el.name} key={el.id}>{el.name}</option>
					})}
				  </select>
				  <div className="invalid-feedback">
					Please select a valid priority.
				  </div>
				</div>
			  </div>
			  <div className="row mb-3"  style={modalStyle}>
				<label htmlFor="status" className="col-sm-3 col-form-label">Status*</label>
				<div className="col-sm-9">
				  <select className="form-select form-select-sm" id="status"
						  required
						  {...register("status")}>
					<option selected value={card.status}>{card.status}</option>
					{statuses.map(el => {
					  return <option value={el.name} key={el.id}>{el.name}</option>
					})}
				  </select>
				  <div className="invalid-feedback">
					Please select a valid status.
				  </div>
				</div>
			  </div>
			  <div className="modal-footer">
			  <button type="submit" className="btn btn-outline-success shadow p-1 mb-2"
					  data-bs-target={`#${card.id}`}
			  >Update</button>
			  <button type="button" className="btn btn-outline-danger shadow p-1 mb-2" data-bs-dismiss="modal">Cancel</button>
			</div>
			</form>
		  </div>
		</div>
	  </div>
	</>
  );
};

export default EditCardModal;
